import { PAYMENT_DETAIL_TYPE } from '../../../../../common/apiConstants';

export const PAYMENT_OUT_PACKAGE_TYPE = [
  PAYMENT_DETAIL_TYPE.MEDICATION_USAGE,
  PAYMENT_DETAIL_TYPE.MEDICAL_SUPPLIES_USAGE,
  PAYMENT_DETAIL_TYPE.INDICATION_REQUEST,
  PAYMENT_DETAIL_TYPE.INDICATION_MEDICATION,
  PAYMENT_DETAIL_TYPE.INDICATION_MEDICAL_SUPPLIES,
];
